@if (emissionChartData$ | async; as chartData) {
  <div class="chart-wrapper">
    @if (
      chartData.get(chartType.EmissionCo2Distribution);
      as emissionDistribution
    ) {
      <div class="chart-wrapper__chart">
        <div
          echarts
          class="chart-wrapper__chart--content"
          [options]="emissionDistribution"></div>
      </div>
    }
    <app-statistics-total
      [totalData]="chartData.get(chartType.EmissionCo2Total) || {}"
      [titleKey]="chartTitle[chartType.EmissionCo2Total]">
    </app-statistics-total>
  </div>
}
